import React from "react";
import $ from 'jquery';


export default class Rreport extends React.Component {
  constructor() {
    super();
    this.state = {
      total_count: "",
      unique_users: "",
    };
  }

  async componentDidMount() {

    window.scrollTo({ top: 0, behavior: 'smooth' });
    var requestOptions = {
      method: "GET",
      redirect: "follow",
    };
    fetch(
      `https://d1zez9d7l5hgkm.cloudfront.net/v1/moderation/swachhpostandusercount`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (
          result &&
          result["resultFlag"] == "1" &&
          result["resultFlag"] == 1
        ) {
          let res = result.response;
          if (res && res.totalPost && res.totalUniqueUser) {
            this.setState({
              total_count: res.totalPost[0].total_count,
              unique_users: res.totalUniqueUser[0].unique_user,
            });
          }
        }
      })
      .catch((error) => console.log("error", error));
  }
  render() {
    return (
      <div className="col-sm-10" style={{ padding: "60px" }}>
        <table>
          <tr>
            <th>Total User</th>
            <th>Total Unique User</th>
          </tr>
          <tr>
            <td>{this.state.total_count}</td>
            <td>{this.state.unique_users}</td>
          </tr>
        </table>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components/SwachhTeerth/Report.jsx